import { useContext, useEffect, useState } from "react"
import PrimaryTextField from "../Components/PrimaryTextField/PrimaryTextField"
import { useTranslation } from "react-i18next";
import PrimaryButton from "../Components/Button/PrimaryButton";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { GlobalStates } from "../GlobalStates";
import { Link } from 'react-router-dom';
import { Validate } from "../functionsIsmesti/validation";
import { t } from 'i18next';
import { useUser } from "../Hooks";


const CreateImone = (props) => {
    const { t } = useTranslation()
    const [password, setPassword] = useState('')
    const [email, setEmail] = useState('')
    const [password2, setPassword2] = useState('')
    const [imone, setImone] = useState('')
    const [tel, setTel] = useState('')
    const [name, setName] = useState('')
    const [disabled, setDisabled] = useState(true)
    const { create } = useUser()
    const userCreate = () => {
        create({
            email: email,
            password: password,
            imonesPavadinimas: imone.trim(),
            tel: tel,
            VP: name,
            username: imone
        })

    }
    useEffect(() => {
        try {
            setDisabled(true)
            if (!Validate(email, 'email')) {
                throw false
            }
            if (!Validate(imone, 'name')) {
                throw false
            }
            if (!Validate(name, 'name')) {
                throw false
            }
            if (!Validate(tel, 'numberValidation')) {
                throw false
            }
            if (!Validate(password, 'password1')) {
                throw false
            }
            setDisabled(false)
        } catch (error) {

        }
    }, [password, email, imone, tel, name])
    return (
        <div className="profilisCont">
            <div className="fakeModal column">
                <p className="name">{t('sukurti_imone')}</p>
                <div className="profilioImonesMargin">
                    <PrimaryTextField
                        label='login_email'
                        onChange={setEmail}
                        fullWidth={true}
                        size='small'
                        classNameForm='biggerTxtMargin'
                        validate='email'
                        errorMsg={t('neteisingasEmail')}
                        autoComplete="new-password"

                    />
                    <PrimaryTextField
                        label='imones_pav'
                        onChange={setImone}
                        fullWidth={true}
                        size='small'
                        classNameForm='biggerTxtMargin'
                        autoComplete="new-password"
                        validate='name'
                        errorMsg={t('iveskiteImone')}
                    />
                    <PrimaryTextField
                        label='vardas_pavarde'
                        onChange={setName}
                        fullWidth={true}
                        size='small'
                        classNameForm='biggerTxtMargin'
                        autoComplete="new-password"
                        validate='name'
                        errorMsg={t('ivestiName')}
                    />
                    <PrimaryTextField
                        label='telNr'
                        onChange={setTel}
                        fullWidth={true}
                        size='small'
                        classNameForm='biggerTxtMargin'
                        validate='numberValidation'
                        errorMsg={t('neteisingasTel')}
                        autoComplete="new-password"
                        
                    />
                    <PrimaryTextField
                        label='login_pass'
                        onChange={setPassword}
                        type={'password'}
                        fullWidth={true}
                        size='small'
                        classNameForm='biggerTxtMargin'
                        autoComplete="new-password"
                        validate='password1'
                        errorMsg={t('iveskitePass')}
                    />
                </div>
                <PrimaryButton
                    text={'registruoti'}
                    onClick={userCreate}
                    className='width100'
                    endIcon={<ArrowForwardIcon />}
                    component={Link}
                    disabled={disabled}
                    to="/"
                />
            </div>
        </div>
    )
}
export default CreateImone